<template>
  <div class="pop style-icon pop-delete">
    <div class="popin">
      <div class="btn-close" @click="emit('onCloseClick')">
        <span class="blind">Close</span>
      </div>
      <div class="pop-con">
        <h2 class="title">
          {{ $t('정말삭제하시겠어요') }}
        </h2>
        <div class="desc">
          {{ $t('삭제후에는복구할수없어요') }}
        </div>
      </div>
      <div class="btns">
        <button class="btn style-lined btn-list" @click="emit('onCloseClick')">
          {{ $t('취소') }}
        </button>
        <button class="btn style-filled" @click="emit('onDeleteClick')">
          {{ $t('삭제') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'onCloseClick'): void
  (e: 'onDeleteClick'): void
}>()
</script>
